import { useToast } from '@chakra-ui/react'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { AsaasRepository, SaveAsaasConfigPayload } from 'data/AsaasRepository'

export function useSaveAsaasConfigMutation() {
	const client = useQueryClient()
	const toast = useToast()

	return useMutation({
		mutationFn: (payload: SaveAsaasConfigPayload) =>
			new AsaasRepository().saveClinicConfig(payload),
		onSuccess: () => {
			toast({
				status: 'success',
				title: 'Configuração salva',
			})
			return client.invalidateQueries({
				queryKey: ['asaas', 'clinic-config'],
			})
		},
		onError: (error) =>
			toast({
				status: 'error',
				title: 'Erro ao salvar Asaas',
				description: error.message,
			}),
	})
}
